import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=07e8e5b0&scoped=true&"
import script from "./message-template.vue?vue&type=script&lang=js&"
export * from "./message-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8e5b0",
  null
  
)

export default component.exports